// extracted by mini-css-extract-plugin
module.exports = {"bb-resources-list":"bb-resources-list__1aRSh"};